"use strict";

const strf = require("./string.format.js");

/*
 *
 * Date utilities class
 *
 */

class MetaStreamIODate {
  constructor({ logger } = {}) {
    this.logger = logger;
  }

  // Generate a UTC timestamp at the time an event occurs
  getEventTimestamp() {
    var event_timestamp = new Date().getTime() * 1000;
    return event_timestamp;
  }

  // Get the current data
  getEventDate() {
    var date = new Date().toISOString().substr(0, 10);
    return date;
  }

  // Return the timezone offset of the device
  getDeviceTimezoneOffset() {
    const newDateNow = new Date();
    return (newDateNow.getTimezoneOffset() * 60) / -1;
  }

  validateDatetime(dt) {
    return new Date(dt).getTime() > 0;
  }
}

module.exports = MetaStreamIODate;
